<template>
  <apexchart
    class="donut-chart"
    :height="height"
    :options="chartOptions"
    :series="series"
    type="donut"
    :width="width"
  />
</template>

<script setup>
import VueApexCharts from 'vue3-apexcharts';
import I18n from 'i18n-js';

const apexchart = VueApexCharts;

const props = defineProps({
  /** Numeric value for the height of a chart */
  height: { type: Number, required: false, default: 100 },
  /** Unique id for the chart. To ensure there is no clashing with multiple charts */
  id: { type: String, required: true, default: '' },
  /** Data for chart labels */
  labels: { type: Array, required: true, default: () => [] },
  /** Data for the chart series */
  series: { type: Array, required: false, default: () => [] },
  /** Numeric value for the width of a chart */
  width: { type: Number, required: false, default: 100 },
});

/**
 * Colours for chart series
 */
const conditionSeriesColours = [
  '#6D7372',
  '#54755E',
  '#92A335',
  '#E89C00',
  '#EB6C0E',
  '#E9413A',
  '#403F40',
];

/**
 * Colours for chart options
 */
const colourConfig = {
  strokeOutline: '#363536',
};

/**
 * Chart options
 * (defines what the chart can do and what it looks like)
 */
const chartOptions = {
  chart: {
    type: 'donut',
    id: props.id,
  },
  colors: conditionSeriesColours,
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    pie: {
      donut: {
        size: '50%',
      },
    },
  },
  stroke: {
    colors: colourConfig.strokeOutline,
    width: 0.8,
  },
  tooltip: {
    enabled: true,
    x: {
      show: true,
      format: 'dd MMM',
      formatter: undefined,
    },
    y: {
      formatter: function (value) {
        return value === 7 ? null : value;
      },
      title: {
        formatter: (seriesName) => {
          return seriesName === 'series-7'
            ? I18n.t('chart.no_data_to_report')
            : `${I18n.t('operations.condition')} ${seriesName}:`;
        },
      },
    },
  },
  labels: props.labels,
  grid: {
    show: false,
    padding: {
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
    },
  },
};
</script>

<style lang="scss">
@import '@/stylesheets/global';
@import '@/stylesheets/components/apexchart_override.scss';
</style>
